<template>
<div class="rg-page" id="register">
  <div class="rg-page__glow rg-page__glow--1" />
  <div class="rg-page__glow rg-page__glow--2" />

  <div class="rg-layout">
    <!-- Columna izquierda -->
    <div class="rg-left">
      <img src="./../assets/Intelligential-logo-texto-blanco.png" class="rg-left__logo" />
      <h1 class="rg-left__title">
        Transforma y digitaliza<br>tu operación financiera
      </h1>
      <div class="rg-features">
        <div class="rg-feature">
          <div class="rg-feature__bullet"><i class="fas fa-bolt" /></div>
          <div class="rg-feature__content">
            <h3>Solicitudes de crédito 100% digitales</h3>
            <p>Recibe, evalúa y aprueba solicitudes en minutos. Digitaliza cada paso y ofrece una experiencia ágil a tus clientes.</p>
          </div>
        </div>
        <div class="rg-feature">
          <div class="rg-feature__bullet"><i class="fas fa-chart-line" /></div>
          <div class="rg-feature__content">
            <h3>Control total de tu cartera</h3>
            <p>Gestiona en tiempo real. Consulta vencimientos, aplica pagos y toma decisiones con indicadores precisos.</p>
          </div>
        </div>
        <div class="rg-feature">
          <div class="rg-feature__bullet"><i class="fas fa-shield-alt" /></div>
          <div class="rg-feature__content">
            <h3>Cumple sin complicaciones</h3>
            <p>Reportes automatizados, validaciones de KYC y alertas que se adaptan a la regulación vigente.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Columna derecha (formulario) -->
    <div class="rg-right">
      <div class="rg-card">
        <form @submit.prevent="onSubmit" autocomplete="off">
          <h2 class="rg-card__title">Registra tu negocio</h2>

          <p class="rg-section-label">Información personal</p>
          <div class="columns is-multiline">
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Nombre(s) <span class="rg-required">*</span></label>
                <input class="input" name="nombrePersona" type="text" v-model="nombrePersona"
                  placeholder="Nombre(s)" v-validate="'required'" :data-vv-as="'Nombre(s)'"
                  :class="{'is-danger': vverrors.has('nombrePersona')}" />
                <p class="is-error" v-if="vverrors.first('nombrePersona')">Ingresa tu nombre</p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Primer apellido <span class="rg-required">*</span></label>
                <input class="input" type="text" v-model="primerApellido" name="primerApellido"
                  placeholder="Primer apellido" v-validate="'required'" :data-vv-as="'Primer apellido'"
                  :class="{'is-danger': vverrors.has('primerApellido')}" />
                <p class="is-error" v-if="vverrors.first('primerApellido')">Ingresa tu primer apellido</p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Segundo apellido</label>
                <input class="input" type="text" name="segundoApellido" v-model="segundoApellido"
                  placeholder="Segundo apellido" :data-vv-as="'Segundo apellido'" />
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Correo electrónico <span class="rg-required">*</span></label>
                <input class="input" type="text" v-model="email" name="email"
                  placeholder="Correo electrónico" v-validate="'required'" :data-vv-as="'Correo electrónico'"
                  :class="{'is-danger': vverrors.has('email')}" />
                <p class="is-error" v-if="vverrors.first('email')">Ingresa tu correo electrónico</p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Contraseña <span class="rg-required">*</span></label>
                <input class="input" type="password" v-model="password" name="password"
                  placeholder="Contraseña" v-validate="'required'" :data-vv-as="'Contraseña'"
                  :class="{'is-danger': vverrors.has('password')}" @input="onInput" />
                <ul v-if="showValidation && password" class="rg-checklist">
                  <li :class="{ 'is-met': validations.length }">
                    <i :class="validations.length ? 'fas fa-check-circle' : 'far fa-circle'" />
                    Al menos 8 caracteres
                  </li>
                  <li :class="{ 'is-met': validations.uppercase }">
                    <i :class="validations.uppercase ? 'fas fa-check-circle' : 'far fa-circle'" />
                    Una letra mayúscula
                  </li>
                  <li :class="{ 'is-met': validations.symbol }">
                    <i :class="validations.symbol ? 'fas fa-check-circle' : 'far fa-circle'" />
                    Un número y un símbolo
                  </li>
                </ul>
                <p class="is-error" v-if="vverrors.first('password')">Ingresa tu contraseña</p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Confirmar contraseña <span class="rg-required">*</span></label>
                <input class="input" type="password" v-model="confirmPassword" name="confirmPassword"
                  placeholder="Confirmar contraseña" v-validate="'required'" :data-vv-as="'Confirmar contraseña'"
                  :class="{'is-danger': vverrors.has('confirmPassword')}" @input="inputconfirmPassword" />
                <p v-if="notMatch" class="is-error">Las contraseñas no coinciden</p>
                <p v-if="!notMatch && !confirmPassword && vverrors.first('confirmPassword')" class="is-error">Reingresa tu contraseña</p>
              </div>
            </div>
          </div>

          <p class="rg-section-label">Información de la empresa</p>
          <div class="columns is-multiline">
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Nombre comercial <span class="rg-required">*</span></label>
                <input class="input" type="text" v-model="nombreEmpresa" name="nombreEmpresa"
                  placeholder="Nombre comercial de la empresa" v-validate="'required'"
                  :data-vv-as="'Nombre comercial de la empresa'" :class="{'is-danger': vverrors.has('nombreEmpresa')}" />
                <p class="is-error" v-if="vverrors.first('nombreEmpresa')">Ingresa el nombre comercial</p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Razón social <span class="rg-required">*</span></label>
                <input class="input" type="text" v-model="nombreLegal" name="nombreLegal"
                  placeholder="Razón social" v-validate="'required'" :data-vv-as="'Razón social'"
                  :class="{'is-danger': vverrors.has('nombreLegal')}" />
                <p class="is-error" v-if="vverrors.first('nombreLegal')">Ingresa la razón social</p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">RFC <span class="rg-required">*</span></label>
                <input class="input is-uppercase" type="text" v-model="rfcEmpresa" name="rfcEmpresa"
                  placeholder="RFC" v-validate="'required'" :data-vv-as="'RFC'"
                  :class="{'is-danger': vverrors.has('rfcEmpresa')}" />
                <p class="is-error" v-if="vverrors.first('rfcEmpresa')">Ingresa tu RFC</p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="rg-label">Cargo en la empresa <span class="rg-required">*</span></label>
                <div class="select is-fullwidth" :class="{'is-danger': vverrors.has('cargoEmpresa')}">
                  <select v-model="cargoEmpresa" name="cargoEmpresa" v-validate="'required'" :data-vv-as="'Cargo'"
                    :class="{'is-danger': vverrors.has('cargoEmpresa')}">
                    <option value="" selected>Seleccione una opción</option>
                    <option value="CPO">Director de producto (CPO)</option>
                    <option value="CCO">Director de Crédito (CCO)</option>
                  </select>
                </div>
                <p class="is-error" v-if="vverrors.first('cargoEmpresa')">Selecciona un cargo</p>
              </div>
            </div>
          </div>

          <div class="field">
            <button class="button is-intelligential is-fullwidth rg-submit" :class="{ 'is-loading': isLoading }">
              Registrarme
            </button>
            <p class="is-error has-text-centered rg-submit-error" v-if="error">{{ error }}</p>
          </div>

          <div class="rg-footer">
            ¿Ya tienes una cuenta? <router-link to="/">Inicia sesión aquí</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>

  <modal-confirmacion-cuenta
    v-if="modalConfirmAccount"
    :close="openModalAccountConfirm"
    :email="email"
    :token="token"
  />
</div>
</template>

<script>
import { mapActions } from 'vuex'
import slugify from 'slugify'
import ModalConfirmacionCuenta from '@/components/Register/modal-confirmacion-cuenta.vue'

export default {
  name: 'RegistroNegocio',
  components: {
    ModalConfirmacionCuenta
  },
  data () {
    return {
      nombrePersona: '',
      primerApellido: '',
      segundoApellido: '',
      email: '',
      password: '',
      confirmPassword: '',
      nombreEmpresa: '',
      nombreLegal: '',
      rfcEmpresa: '',
      cargoEmpresa: '',
      modalConfirmAccount: false,
      error: null,
      isLoading: false,
      showValidation: false,
      validations: {
        length: false,
        uppercase: false,
        symbol: false
      },
      notMatch: false,
      token: ''
    }
  },
  methods: {
    ...mapActions(['createFinancialCompany']),
    async onSubmit () {
      const identifier = slugify(this.nombreEmpresa, {
        lower: true,
        strict: true,
        locale: 'es'
      })
      this.error = null
      if (await this.$validator.validateAll() && this.password === this.confirmPassword) {
        this.isLoading = true
        const result = await this.createFinancialCompany({
          financialCompany: {
            name: this.nombreEmpresa,
            legalName: this.nombreLegal,
            publicName: this.nombreEmpresa,
            fiscalName: this.nombreLegal,
            identity: this.rfcEmpresa.toUpperCase(),
            identifier: identifier
          },
          user: {
            name: this.nombrePersona,
            lastName: this.primerApellido,
            email: this.email,
            password: this.password
          }
        })
        if (result?.success) {
          this.modalConfirmAccount = !this.modalConfirmAccount
          this.$validator.reset()
          this.isLoading = false
        }

        if (result?.isError) {
          this.error = result?.message
          this.isLoading = false
        }
      }
    },
    openModalAccountConfirm () {
      this.modalConfirmAccount = !this.modalConfirmAccount
    },
    onInput () {
      if (!this.showValidation && this.password.length > 0) {
        this.showValidation = true
      } else if (this.password.length <= 0) {
        this.showValidation = false
      }
      this.validatePassword()
    },
    validatePassword () {
      const value = this.password
      this.validations.length = value.length >= 8
      this.validations.uppercase = /[A-Z]/.test(value)
      this.validations.symbol = /\d/.test(value) && /[^A-Za-z0-9]/.test(value)
    },
    getClass (isValid) {
      return isValid ? 'has-text-success' : 'has-text-danger'
    },
    inputconfirmPassword () {
      if (this.confirmPassword.length > 0 && this.confirmPassword !== this.password) {
        this.notMatch = true
      } else {
        this.notMatch = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

// ── Page shell ──────────────────────────────────────────────
.rg-page {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(135deg, #0d1525 0%, #152038 60%, #1a2d4a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 3rem 2rem;

  &__glow {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    filter: blur(90px);

    &--1 {
      width: 500px;
      height: 500px;
      background: radial-gradient(circle, rgba(76, 112, 255, 0.15), transparent 70%);
      top: -100px;
      right: -60px;
    }
    &--2 {
      width: 350px;
      height: 350px;
      background: radial-gradient(circle, rgba(117, 167, 216, 0.1), transparent 70%);
      bottom: -60px;
      left: -40px;
    }
  }
}

// ── Two-column layout ────────────────────────────────────────
.rg-layout {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  width: 100%;
  max-width: 1100px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
}

// ── Left column ──────────────────────────────────────────────
.rg-left {
  &__logo {
    height: 30px;
    width: auto;
    margin-bottom: 2.5rem;
    opacity: 0.9;
  }

  &__title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: #fff;
    line-height: 1.3;
    margin-bottom: 0;
  }
}

.rg-features {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.rg-feature {
  display: flex;
  gap: 1rem;
  align-items: flex-start;

  &__bullet {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(76, 112, 255, 0.18);
    border: 1px solid rgba(76, 112, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7b9fff;
    font-size: 0.8rem;
  }

  &__content {
    h3 {
      font-size: 0.9rem;
      font-weight: 600;
      color: #fff;
      margin: 0 0 0.35rem;
    }
    p {
      font-size: 0.85rem;
      color: rgba(255, 255, 255, 0.5);
      margin: 0;
      line-height: 1.6;
    }
  }
}

// ── Right column / card ──────────────────────────────────────
.rg-right {
  @media (max-width: 900px) {
    order: -1;
  }
}

.rg-card {
  background: #fff;
  border-radius: 16px;
  padding: 2.25rem 2rem;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.35);

  &__title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #1a2035;
    text-align: center;
    margin-bottom: 1.5rem;
  }
}

// ── Form elements ────────────────────────────────────────────
.rg-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 0.3rem;
}

.rg-required {
  color: #ff3860;
}

.rg-section-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #9ca3af;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 0.5rem;
  margin-bottom: 0.75rem;
}

.rg-checklist {
  list-style: none;
  margin: 0.5rem 0 0;
  padding: 0.5rem 0.75rem;
  background: #f8f9fb;
  border: 1px solid #e8ecf0;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  li {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.75rem;
    color: #9ba3af;
    transition: color 0.2s ease;

    i { font-size: 0.72rem; transition: color 0.2s ease; }

    &.is-met { color: #2ecc87; i { color: #2ecc87; } }
  }
}

.rg-submit {
  margin-top: 1.25rem;
  height: 42px;
  font-size: 0.95rem;
}

.rg-submit-error {
  margin-top: 0.75rem;
  font-size: 0.875rem;
}

.rg-footer {
  font-size: 0.8rem;
  color: #6b7280;
  text-align: center;
  margin-top: 1.25rem;

  a {
    color: $blue;
    font-weight: 600;
    text-decoration: none;

    &:hover { text-decoration: underline; }
  }
}

.field {
  margin-bottom: 0;
}

.columns {
  margin-bottom: 0;
}
</style>
